import React from 'react';
import { context } from '../../context';

const IsVerifiedPurchase = () => {
  const { urlData } = React.useContext(context);
  const { skuId, deliveryId, orderId } = urlData;
  if (!!skuId && !!deliveryId && !!orderId) {
    return true;
  }
  return false;
};

export default IsVerifiedPurchase;
export { IsVerifiedPurchase };
